import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { SQUARE } from '@utils/image';

import Carousel from '@common/components/Carousel';
import { Hr } from '@common/components/Hr';

import {
  ImagesWrapperDesktop,
  ImagesWrapperMobile,
  HeroLazyImg,
  ZoomButton,
  Discount,
  ImagesContainerDesktop,
} from './Image.styled';

const breakpoints = {
  1: {
    slidesPerView: 1,
    spaceBetween: 0,
  },
};

const Image = forwardRef(
  ({ images, handleImageZoom, imageAlt, discount, shouldAnimate }, ref) => {
    const defaultImageProps = {
      alt: imageAlt,
      widths: [1050, 950, 810, 710, 600, 470, 640, 480, 375],
      aspectRatios: SQUARE,
    };

    return (
      <>
        <ImagesWrapperDesktop>
          <ImagesContainerDesktop
            ref={ref}
            shouldAnimate={shouldAnimate}
          >
            {images.map((image, index) => (
              <ZoomButton
                key={image}
                onClick={() => handleImageZoom(index)}
              >
                <HeroLazyImg
                  {...defaultImageProps}
                  key={image}
                  src={image}
                  forceShow={index === 0}
                  disableAbsolute
                  shouldLazyLoad
                />
              </ZoomButton>
            ))}

            {!!discount && (
              <Discount data-testid="productDiscount">
                {`− ${discount}%`}
              </Discount>
            )}
          </ImagesContainerDesktop>
        </ImagesWrapperDesktop>

        <ImagesWrapperMobile>
          <Carousel
            breakpoints={breakpoints}
            hideNav={images.length <= 1}
            hideScrollbar
            withCounter
            infinite
          >
            {images.map((image, index) => (
              <ZoomButton
                key={image}
                onClick={() => handleImageZoom(index)}
              >
                <HeroLazyImg
                  {...defaultImageProps}
                  key={image}
                  src={image}
                  forceShow={index === 0}
                  shouldLazyLoad
                />
              </ZoomButton>
            ))}
          </Carousel>

          {!!discount && (
            <Discount withAdditionalSpacing={images?.length > 1}>
              {`− ${discount}%`}
            </Discount>
          )}

          {images.length > 1 && (
            <Hr
              spacings={['equal', 4]}
              color={"bluegrey['80']"}
            />
          )}
        </ImagesWrapperMobile>
      </>
    );
  },
);

Image.displayName = 'Image';

Image.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleImageZoom: PropTypes.func.isRequired,
  imageAlt: PropTypes.string.isRequired,
  discount: PropTypes.number,
  shouldAnimate: PropTypes.bool,
};

Image.defaultProps = {
  discount: null,
  shouldAnimate: false,
};

export default Image;
